import type { GetStaticProps, NextPage } from "next";
import { LandingPage } from "src/domains/shared/components/Home/Landing/LandingPage";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";

const Home: NextPage = () => (
  <SiteLayout>
    <LandingPage />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default Home;
